import React, { useEffect, useState } from "react";
import { isEmpty } from "lodash";
import { Table } from "antd";
import { connect } from "react-redux";

import TransfersFilters from "../TransfersFilters";

import Spinner from "./../../../stats/components/Spinner";
import columns from "./TransfersCompany.utils";

const TransfersCompany = ({
  handleTransferOrderGenerated,
  isTransfersLoading,
  token,
  userRoleId,
  transfersByUsers = []
}) => {
  const [userSelectedIds, setUserSelectedIds] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState();
  const [selectedCompanyId, setSelectedCompanyId] = useState();
  const [selectedUserName, setSelectedUserName] = useState();
  const [rowKeysSelected, setRowKeySelected] = useState([]);

  useEffect(() => {
    setRowKeySelected([]);
  }, [selectedCompanyId]);

  const rowSelection = {
    selectedRowKeys: rowKeysSelected,
    onChange: (selectedRowKeys, selectedRows) => {
      setRowKeySelected(selectedRowKeys);
      if (!selectedRows || isEmpty(selectedRows)) setUserSelectedIds(null);
      else setUserSelectedIds(selectedRows.map(item => item.user_id));
    },
    getCheckboxProps: record => ({
      disabled: record.name === "Disabled User",
      name: record.name
    })
  };

  const getTableData =
    transfersByUsers &&
    transfersByUsers.filter(
      transfersByUser =>
        (!selectedCompanyId || selectedCompanyId === transfersByUser.user_company_id) &&
        transfersByUser.status &&
        (!selectedStatus || selectedStatus === transfersByUser.status.label) &&
        (!selectedUserName || selectedUserName === transfersByUser.user_fullname)
    );

  const handleTableOnChange = pagination => {
    setRowKeySelected([]);
  };

  const onSelectAllPremium = () => {
    //when selecting all
    if (!selectedCompanyId) {
      alert("veuillez d'abord sélectionner une compagnie");
      setUserSelectedIds([]);
      setRowKeySelected([]);
    } else if (isEmpty(userSelectedIds)) {
      setUserSelectedIds(getTableData.filter(item => item.total > 0).map(i => i.user_id));
      setRowKeySelected(
        getTableData.reduce((acc, cur, index) => {
          if (cur.total > 0 && cur.user_company_id === selectedCompanyId) {
            acc.push(index);
          }
          return acc;
        }, [])
      );
    } else {
      setUserSelectedIds([]);
      setRowKeySelected([]);
    }
  };

  if (isTransfersLoading) return <Spinner />;
  return (
    <div>
      <TransfersFilters
        handleTransferOrderGenerated={handleTransferOrderGenerated}
        userSelectedIds={userSelectedIds}
        setSelectedStatus={setSelectedStatus}
        setSelectedCompanyId={setSelectedCompanyId}
        setSelectedUserName={setSelectedUserName}
        token={token}
        userRoleId={userRoleId}
        data={getTableData}
        selectedCompanyId={selectedCompanyId}
        menuItem="company"
      />
      <Table
        rowKey={(_, index) => index}
        onChange={handleTableOnChange}
        rowSelection={{
          ...rowSelection,
          selectedRowKeys: rowKeysSelected,
          getCheckboxProps: item => ({
            disabled: item.total < 0
          }),
          onSelectAll: () => onSelectAllPremium()
        }}
        columns={columns}
        dataSource={getTableData}
        pagination={false}
      />
    </div>
  );
};

const mapStateToProps = state => {
  return {
    token: state.auth.token,
    userRoleId: state.userInfos.role_id,
    transfersByUsers: state.transfers.listByUsers,
    isTransfersLoading: state.transfers.isLoading
  };
};

export default connect(mapStateToProps)(TransfersCompany);



// WEBPACK FOOTER //
// src/modules/presence/transfers/transfersCompany/TransfersCompany.js